const dco = props => props.children;
export default dco;
